export default __webpack_public_path__ + "f75c62b5f17b611db7d18e7cb044bbf3.png";